import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function ObjectionsSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Esto es para cualquier religión?',
    a: 'Este material está basado en una relación personal con Dios. Si crees en Él, esto es para ti, independientemente de tu denominación.'
  }, {
    q: '¿Y si mi situación es demasiado grave?',
    a: 'Este manual fue escrito específicamente para situaciones graves. No para los que están "más o menos bien".'
  }, {
    q: '¿Cuánto tiempo me tomará leerlo?',
    a: 'El ebook tiene lectura diseñada para crisis. Puedes leer un capítulo por día. El Plan de 21 días hace el resto.'
  }, {
    q: '¿Y si no siento nada al orar?',
    a: 'El Capítulo 3 responde exactamente eso. El silencio en la oración es parte del proceso. Te enseñamos qué hacer en él.'
  }, {
    q: '¿Esto reemplaza terapia o consejería?',
    a: 'No. Es un complemento espiritual y emocional. Si necesitas ayuda profesional, te animamos a buscarla también.'
  }];
  const toggle = (i: number) => setOpenIndex(openIndex === i ? null : i);
  return <section className="py-12 px-6" style={{
    backgroundColor: 'var(--bg-surface)'
  }} data-id="element-213">
      <div className="max-w-[680px] mx-auto" data-id="element-214">
        <h2 className="text-2xl font-serif text-center mb-8 text-[var(--text-heading)]" data-id="element-215">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-2" data-id="element-216">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-[var(--bg-card)] rounded-lg border border-[var(--border-subtle)] shadow-sm overflow-hidden" data-id="element-217">
              <button onClick={() => toggle(i)} className="w-full flex items-center justify-between gap-4 p-5 text-left" data-id="element-218">
                <span className="font-serif font-bold text-[var(--text-heading)] text-base leading-snug" data-id="element-219">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === i ? 180 : 0
            }} transition={{
              duration: 0.25
            }} className="flex-shrink-0 text-[var(--accent)]" data-id="element-220">
                  <ChevronDown className="w-5 h-5" data-id="element-221" />
                </motion.div>
              </button>

              <AnimatePresence initial={false} data-id="element-222">
                {openIndex === i && <motion.div key="content" initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-223">
                    <p className="px-5 pb-5 text-[var(--text-muted)] text-sm leading-relaxed border-t border-[var(--border-subtle)] pt-4" data-id="element-224">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}